<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="fill-height pa-0 mt-0 chat-drawer-container fluid">      
      <template v-if="!$vuetify.breakpoint.smAndDown">
        <v-layout row>
          <v-flex lg8 class="chat-contact--sidebar white">
            <partai-list></partai-list>
          </v-flex>
          <v-flex lg4 v-if="showWindow">
            <partai-view></partai-view>
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <v-layout column>
          <v-flex sm12 class="white" v-if="showSidebar">
            <partai-list></partai-list>
          </v-flex>
          <v-flex sm12 v-if="showWindow">
            <partai-view></partai-view>
          </v-flex>
        </v-layout>        
      </template>
    </v-container>
  </v-slide-y-transition>  
</template>
<script>
import PartaiList from './list';
import PartaiView from './view';

var _  = require('lodash');

export default {
  components: {
    PartaiList,
    PartaiView
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
    };
  },
  computed: {
    showSidebar () {
      return this.$route.query.id === undefined;
    },
    showWindow () {
      return this.$route.query.id !== undefined;
    },    
  },
};
</script>

